export enum ViewGridFooterBlock {
  Root = 'ViewGridFooter',
}
